import React from 'react';
import PermissionMatrix from './PermissionMatrix';

const Administrative = (props) => (
  <PermissionMatrix
    {...props}
    areaLabel="Administrativo"
    hierarchy={['Diretor', 'Gerente', 'Analista', 'Estagiário']}
  />
);

export default Administrative;
